import { put, takeEvery } from "redux-saga/effects";
import type { SpEnvironmentType } from "InterfacesTypes/types"
import { loadSpEnvironment, markInitialized, setSpEnvironment } from "state/Reducers/SPEnvironmentReducer";

function* loadSpEnvironmentSaga() {
   const spEnv: SpEnvironmentType = window.location.hostname
    .split(".")[0] === "logistikportalen" ? "logistikportalen" : "logp";

//    Use if you want to test the app to see how it looks on logistikportalen.
  //  const spEnv: SpEnvironmentType = "logistikportalen";

    if (spEnv) {
        yield put(setSpEnvironment(spEnv));
    }

    yield put(markInitialized());
}

export function* spEnvironmentSaga() {
    yield takeEvery(loadSpEnvironment.type, loadSpEnvironmentSaga);
}